import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useAuthentication } from '@hooks/useAuthentication'

export function withAuthenGuard(Component: React.FC<any>) {
  function WithAuthenGuard(props: any) {
    const { isUserLoading, isAuthenticated } = useAuthentication()
    const { push } = useRouter()

    useEffect(() => {
      if (!isUserLoading && !isAuthenticated) {
        push('/')
      }
    }, [isUserLoading, isAuthenticated, push])

    // if (isUserLoading || !isAuthenticated) {
    //   return <></>
    // }

    if (isAuthenticated) {
      return <Component {...props} />
    }

    return null
  }

  return WithAuthenGuard
}
